module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// MobileWelcome

(function (fox, $) {
	
	fox.registerWidget('MobileWelcome', {

		configure: function () {
			this.registerOptions('', {
				template: 'sitepage_home_welcome_video',
				'embed.container': '.welcome-block',
				autoRender: false,
				'widgets.api': {
					widget: 'Api',
					method: 'site.welcome.get',
					cacheChannel: 'site'
				},
				handleWom: {
					apiSuccessHandler: {
						event: 'success',
						widget: '#api',
						callback: 'apiSuccessHandler'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this
				.rwom1('#api')
				.send();
		
			this.callParent('running', arguments);
		},

		apiSuccessHandler: function (response) {
			if (response.answer.status === true && 
				!fox.isEmpty(response.answer.response)) {
				this
					.setTemplateOptions(response.answer.response)
					.render();
			}
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/mobileWelcome.js
// module id = 854
// module chunks = 4